export const CacheKeys = {
  Menu: 'menu',
  Pages: 'pages',
  PageTemplates: 'page_templates',
  Pillars: 'pillars--',
  WhatsNew: 'whats_new',
  Config: 'config',
  RssFeeds: 'rss_feeds',
  BatchRssFeeds: 'batch--feeds--',
  FeedImage: 'feed--image--',
  PillarMeta: 'pillar_meta',
  FaqPages: 'faq_pages',
  Offers: 'offers',
  Cities: 'cities',
  AirtimeAdvanceOffers: 'aa_offers',
  AirtimeAdvanceBalances: 'aa_balances',
  AirtimeAdvanceHistory: 'aa_history',
  AirtimeAdvanceEligibility: 'aa_simswap',
  VoucherAdvanceCategories: 'va_categories',
  VoucherAdvanceProductList: 'va_product_list',
  VoucherAdvanceProductInfo: 'va_product_info',
  VoucherAdvanceEligibility: 'va_eligibility',
  VoucherAdvanceLoanHistory: 'va_history',
  VoucherAdvanceOpenLoans: 'va_open_loans',
  VoucherAdvanceRewardHistory: 'va_reward_history',
  Volatile: 'volatile',
  VoucherAdvanceRedemptionHistory: 'va_redemption_history',
  AdvancePrompt: 'advance_prompt',
  ConfigContext: 'config_context',
  PromotionBanner: 'promotion_banner',
  Promotions: 'promotions',
  SocialBundles:  'social_bundles'
};
